import type { ApiClient } from '../../api/client';
import type { EmployeeHomePort } from '../../features/home/public';

export function createEmployeeHomeHttpAdapter(client: ApiClient): EmployeeHomePort {
  return {
    async loadWorker(workerId) {
      const worker = await client.getWorker(workerId);
      return { displayName: worker.descriptor };
    },

    async loadBalances(workerId) {
      const response = await client.listTimeOffBalances(workerId);
      return response.data.map((balance) => ({
        label: balance.timeOffPlan.descriptor,
        asOf: balance.asOf,
        balance: balance.balance,
        accrued: balance.accrued,
        carryOver: balance.carryOver,
        used: balance.used,
      }));
    },
  };
}
